import { render, staticRenderFns } from "./retrievalStatistics.vue?vue&type=template&id=72d21d7c"
import script from "./retrievalStatistics.vue?vue&type=script&lang=js"
export * from "./retrievalStatistics.vue?vue&type=script&lang=js"
import style0 from "./retrievalStatistics.vue?vue&type=style&index=0&id=72d21d7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports